import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/helpers/src/internationalization/react';
import {fontSizes, fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';
import {boxShadow} from '../../../../../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {emojiMap} from '../../../../../../services/emojis/emojis';
import {InlineEmoji} from '../../../../../common/emoji/inlineEmoji';

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  position: absolute;
  bottom: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBannerContent = styled.div`
  pointer-events: auto;
  border-radius: 18px;

  color: ${(p) => p.theme.greys.white};
  background-color: ${(p) => p.theme.palette.pink.shade40};
  ${(p) => boxShadow(p.theme, `0 2px 10px 0 rgba(0, 0, 0, 0.2)`)};

  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.medium};

  padding: 9px 13px;
`;

const StyledEmojiSpan = styled.span`
  padding-right: 10px;
`;

/*
 * Component.
 */

export const DemoConversationBanner: FC = () => (
  <StyledWrapperDiv>
    <StyledBannerContent>
      <Trans id="composer-banner-demoinbox">
        <StyledEmojiSpan>
          <InlineEmoji emoji={emojiMap.point_down} size={16} />
        </StyledEmojiSpan>
        Leave yourself a note or @mention someone below – this is just sample content!
      </Trans>
    </StyledBannerContent>
  </StyledWrapperDiv>
);
